module.exports = __webpack_public_path__ + "static/img/per17.f3e28fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per17.jpg
// module id = wh1r
// module chunks = 41